
export default function sortDate(order) {
  return (obj1, obj2) => {
    let val1 = new Date(obj1.data);
    let val2 = new Date(obj2.data);
    return (val1 - val2) * (order === 'asc' ? 1 : -1);
  };
}